export default __webpack_public_path__ + "img/bg-content-404.jpg?67d3";